import React from "react";
import ApprovalSummary from "./approvalSummary";
import CapexApproval from "./CapexApproval";

const SummaryRenderer = () => {
	return (
		<>
			<ApprovalSummary />
			<CapexApproval />
		</>
	);
};

export default SummaryRenderer;
